import React from 'react';

import Article from '../../../../app/components/blocks/Article.jsx';
import ExtraReading from '../../../../app/components/blocks/ExtraReading.jsx';
import KeyLearning from '../../../../app/components/blocks/KeyLearning.jsx';
import FormAnswer from '../../../../app/components/forms/FormAnswer.jsx';

const ArticlePreview = ({
  article,
  children,
}) => (
  <div className="container-fluid">
    <div className="row">
      <div className="col">
        {children}
        <Article article={article} />
        <div className="readable">
          {article.keyLearning && (
            <KeyLearning>
              {article.keyLearning}
            </KeyLearning>
          )}
          {article.extraReading && article.extraReading.url && (
            <ExtraReading
              extraReading={article.extraReading}
            />
          )}
        </div>
      </div>
      <div
        className="col-12 col-md col-lg-auto bg-paper pt-4"
        style={{ width: '460px' }}
      >
        <FormAnswer
          questions={article.questions}
          showAns={true}
          disabled={true}
        />
      </div>
    </div>
  </div>
);

export default ArticlePreview;
